export default "__VITE_ASSET__CL6ZLnuX__"